// extracted by mini-css-extract-plugin
module.exports = {"downloadModal":"styles_downloadModal__1GOI8","desktopOverlay":"styles_desktopOverlay__1allJ","desktopClose":"styles_desktopClose__3bImc"};